import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FileUploadDialogComponent } from './file-upload-dialog.component';
import { FileUploadDialogData, FileUploadDialogResult } from './file-upload-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class FileUploadDialogService {
  constructor(private readonly matDialog: MatDialog) {}
  openDialog(data: FileUploadDialogData) {
    return this.matDialog.open<FileUploadDialogComponent, FileUploadDialogData, FileUploadDialogResult>(
      FileUploadDialogComponent,
      {
        maxWidth: '100vw',
        maxHeight: '100vh',
        height: '500px',
        width: '500px',
        data,
      },
    );
  }
}
